import {
  PaymentMethod,
  AccessType,
  Challenge,
  State as ChallengeState,
  DurationUnit,
} from '@wix/ambassador-challenges-v1-challenge/types';
import { ParticipantSection, ParticipantStep } from '../../../types/v3Types';
import { StepType } from '@wix/ambassador-online-programs-v3-step/types';

const MOCK_ID =
  'f2e85b46-014b-4c66-80f7-477d653014bb-sgsgseg-sgfsegsehdjtfjgyjgyjgyj';
let mockCount = 1;

const generateMockId = () => {
  return `${MOCK_ID}-${++mockCount}`;
};

export const flexibleChallengeWeeks: Challenge = {
  participantsSummary: {
    participantsNumber: 10,
  },
  id: generateMockId(),

  transitions: [{ state: [ChallengeState.PUBLISHED] as any }],
  settings: {
    description: {
      title: '3-Week Challenge with Price and 12 Participants',
      media: {},
    },
    accessRestrictions: {
      accessType: AccessType.PUBLIC,
      maxParticipants: 15,
    },
    timelineType: {
      flexible: {
        duration: {
          unit: DurationUnit.WEEKS,
          value: 3,
        },
      },
    },
    pricing: {
      singlePayment: {
        price: {
          currency: 'USD',
          amount: '123.01',
        },
        allowedMethods: [PaymentMethod.OFFLINE_PAYMENT],
      },
    },
  },
};

export const flexibleChallengeDay: Challenge = {
  participantsSummary: {
    participantsNumber: 10,
  },
  id: generateMockId(),

  transitions: [{ state: [ChallengeState.PUBLISHED] as any }],
  settings: {
    description: {
      title: '3-Week Challenge with Price and 12 Participants',
      media: {},
    },
    accessRestrictions: {
      accessType: AccessType.PUBLIC,
      maxParticipants: 15,
    },
    timelineType: {
      flexible: {
        duration: {
          unit: DurationUnit.WEEKS,
          value: 3,
        },
      },
    },
    pricing: {
      paidPlans: [{ id: 'f2e85b46-014b-4c66-80f7-477d653014bb' }],
    },
  },
};

export const userPaidPlans = [
  {
    id: 'f2e85b46-014b-4c66-80f7-477d653014bb',
    roleId: 'f2e85b46-014b-4c66-80f7-477d653014bb',
    details: {
      name: 'Plan Name',
      description: 'Tagline',
      ribbon: '',
      benefits: ['Plan benefits'],
      disclaimer: '',
    },
    challenges: [flexibleChallengeDay.id],
    paymentOptions: {
      price: {
        amount: '150',
        currency: 'USD',
      },
      recurring: false,
      validFor: {
        forever: false,
        period: {
          amount: 1,
          unit: 'MONTH',
        },
      },
    },
    visible: true,
    archived: false,
    primary: false,
    hasOrders: false,
    dateCreated: '2019-11-26T10:28:24.946Z',
    dateUpdated: '2019-11-26T10:28:24.946Z',
    slug: 'plan-name',
    template: false,
  },
];

export const CLASSIC_MEDIA = {
  image: {
    width: 400,
    id: 'a0a875_94a2a4699c3c4df187c6cda6969855e4~mv2.jpg',
    url: 'media/a0a875_94a2a4699c3c4df187c6cda6969855e4~mv2.jpg',
    height: 300,
  },
};

export const VIDEO_MEDIA = {
  video: {
    id: 'a0a875_94a2a4699c3c4df187c6cda6969855e3',
    url: '',
    width: 800,
    height: 600,
    thumbnail: {
      width: 400,
      id: 'a0a875_94a2a4699c3c4df187c6cda6969855e4~mv2.jpg',
      url: 'media/a0a875_94a2a4699c3c4df187c6cda6969855e4~mv2.jpg',
      height: 300,
    },
  },
};

const INITIAL_CHALLENGE: Omit<Challenge, 'timelineType'> = {
  id: generateMockId(),
  participantsSummary: {
    participantsNumber: 10,
  },

  transitions: [{ state: [ChallengeState.PUBLISHED] as any }],
  settings: {
    rewards: [],
    pricing: {},
    completionCriteria: {
      completedSteps: {
        all: true,
        minThreshold: {
          value: 10,
        },
      },
      completedMilestones: {
        minThreshold: {
          value: 10,
        },
        all: true,
      },
      scoredPoints: {
        value: 10,
      },
    },
    accessRestrictions: {
      maxParticipants: 15,
      accessType: AccessType.PUBLIC,
    },
  },
};

type IMockedChallenge = Challenge & { shouldTranslateTitle: boolean };

export const FLEXIBLE_CHALLENGE1: IMockedChallenge & { mocked: boolean } = {
  ...INITIAL_CHALLENGE,
  mocked: true, // to check on challenge page in editor
  shouldTranslateTitle: true, // for mocked challenges
  participantsSummary: {
    participantsNumber: 10,
    joinRequestsNumber: 0,
    invitationsNumber: 0,
  },
  stepsSummary: {
    stepsNumber: 15,
  },
  owners: [
    {
      id: 'a0a8750a-8dbe-4c75-8b15-54d9ed384fac',
      fullName: 'Site Owner',
      contactId: '99a65e13-d621-4e49-adf9-46d2fe944a6f',
    },
  ],
  settings: {
    ...INITIAL_CHALLENGE.settings,
    description: {
      media: {
        image: {
          width: 400,
          url: 'media/a0a875_9849fd794f234a5c82ff357a3ffa7164~mv2.jpg',
          id: 'a0a875_9849fd794f234a5c82ff357a3ffa7164~mv2.jpg',
          height: 300,
        },
      },
      title: 'editor.challenge.mocked-1.title',
      details:
        'Include a general overview of your challenge so that participants know what to expect. Also, tell participants about any prerequisites or special preparation they need to do before the challenge. You can write an inspirational message that motivates participants to give it their all and achieve their goals.',
    },
    timelineType: {
      flexible: {
        duration: {
          unit: DurationUnit.DAYS,
          value: 21,
        },
      },
    },
  },
};

export const FLEXIBLE_CHALLENGE2: IMockedChallenge = {
  ...INITIAL_CHALLENGE,
  shouldTranslateTitle: true,
  settings: {
    ...INITIAL_CHALLENGE.settings,
    description: {
      media: {
        image: {
          width: 400,
          id: 'a0a875_94a2a4699c3c4df187c6cda6969855e4~mv2.jpg',
          url: 'media/a0a875_94a2a4699c3c4df187c6cda6969855e4~mv2.jpg',
          height: 300,
        },
      },
      title: 'editor.challenge.mocked-2.title',
      details: '',
    },
    timelineType: {
      flexible: {
        duration: {
          unit: DurationUnit.DAYS,
          value: 21,
        },
      },
    },
  },
};

export const FLEXIBLE_CHALLENGE3: IMockedChallenge = {
  ...INITIAL_CHALLENGE,
  shouldTranslateTitle: true,
  settings: {
    ...INITIAL_CHALLENGE.settings,
    description: {
      media: {
        image: {
          width: 400,
          id: 'a0a875_0a13877b9eb1427d835fb3257eecde25~mv2.jpg',
          url: 'media/a0a875_0a13877b9eb1427d835fb3257eecde25~mv2.jpg',
          height: 300,
        },
      },
      title: 'editor.challenge.mocked-3.title',
      details: '',
    },
    timelineType: {
      flexible: {
        duration: {
          unit: DurationUnit.DAYS,
          value: 21,
        },
      },
    },
  },
};

export const CHALLENGES = [
  { challenge: FLEXIBLE_CHALLENGE1 },
  { challenge: FLEXIBLE_CHALLENGE2 },
  { challenge: FLEXIBLE_CHALLENGE3 },
];

export const CHALLENGES_CLASSIC_CHANGED = [
  {
    challenge: {
      ...FLEXIBLE_CHALLENGE1,
      participantsSummary: {
        ...FLEXIBLE_CHALLENGE1.participantsSummary,
        participantsNumber: 10,
      },
      settings: {
        ...FLEXIBLE_CHALLENGE1.settings,
        description: {
          media: {
            image: {
              width: 400,
              id: '0b9ef3_7a834cb592d247cbac09fe1d18f442f3~mv2.jpg',
              url: 'media/0b9ef3_7a834cb592d247cbac09fe1d18f442f3~mv2.jpg',
              height: 300,
            },
          },
          title: 'editor.challenge.mocked-1.title-changed',
          details: '',
        },
        timelineType: {
          flexible: {
            duration: {
              unit: DurationUnit.DAYS,
              value: 21,
            },
          },
        },
      },
    } as IMockedChallenge,
  },
  {
    challenge: {
      ...FLEXIBLE_CHALLENGE2,
      participantsSummary: {
        ...FLEXIBLE_CHALLENGE2.participantsSummary,
        participantsNumber: 17,
      },
      settings: {
        ...FLEXIBLE_CHALLENGE2.settings,
        description: {
          media: {
            image: {
              width: 400,
              id: '0b9ef3_baf2b064f9824f81908a51ef4759b59a~mv2.jpg',
              url: 'media/0b9ef3_baf2b064f9824f81908a51ef4759b59a~mv2.jpg',
              height: 300,
            },
          },
          title: 'editor.challenge.mocked-2.title-changed',
          details: '',
        },
        timelineType: {
          flexible: {
            duration: {
              unit: DurationUnit.DAYS,
              value: 7,
            },
          },
        },
        pricing: {
          singlePayment: {
            price: {
              amount: '9.99',
              currency: 'USD',
            },
          },
        },
      },
    } as IMockedChallenge,
  },
  {
    challenge: {
      ...FLEXIBLE_CHALLENGE3,
      participantsSummary: {
        ...FLEXIBLE_CHALLENGE3.participantsSummary,
        participantsNumber: 29,
      },
      settings: {
        ...FLEXIBLE_CHALLENGE3.settings,
        description: {
          media: {
            image: {
              width: 400,
              id: '0b9ef3_955324e67a6f465d85ff9e95161a7ceb~mv2.jpg',
              url: 'media/0b9ef3_955324e67a6f465d85ff9e95161a7ceb~mv2.jpg',
              height: 300,
            },
          },
          title: 'editor.challenge.mocked-3.title-changed',
          details: '',
        },
        timelineType: {
          flexible: {
            duration: {
              unit: DurationUnit.DAYS,
              value: 10,
            },
          },
        },
      },
    } as IMockedChallenge,
  },
];

const EDITORX_MEDIA = {
  MealForRunners: {
    image: {
      width: 1200,
      id: 'a0a875_ce06cede44414c9989603c9690070746~mv2.jpg',
      url: 'media/a0a875_ce06cede44414c9989603c9690070746~mv2.jpg',
      height: 1200,
    },
  },
  RunYourFirst: {
    image: {
      width: 1200,
      id: 'a0a875_a6961ed3f19b44d994235720b4a3cf42~mv2.jpg',
      url: 'media/a0a875_a6961ed3f19b44d994235720b4a3cf42~mv2.jpg',
      height: 1200,
    },
  },
  MarathonTraining: {
    image: {
      width: 1200,
      id: 'a0a875_2419a6dfc2a24ee9a003a63038f86dd3~mv2.jpg',
      url: 'media/a0a875_2419a6dfc2a24ee9a003a63038f86dd3~mv2.jpg',
      height: 1200,
    },
  },
};

export const CHALLENGES_EDITORX = [
  {
    challenge: {
      ...FLEXIBLE_CHALLENGE1,
      settings: {
        ...FLEXIBLE_CHALLENGE1.settings,
        description: {
          ...FLEXIBLE_CHALLENGE1.settings.description,
          media: EDITORX_MEDIA.RunYourFirst,
        },
      },
    },
  },
  {
    challenge: {
      ...FLEXIBLE_CHALLENGE2,
      settings: {
        ...FLEXIBLE_CHALLENGE2.settings,
        description: {
          ...FLEXIBLE_CHALLENGE2.settings.description,
          media: EDITORX_MEDIA.MarathonTraining,
        },
      },
    },
  },
  {
    challenge: {
      ...FLEXIBLE_CHALLENGE3,
      settings: {
        ...FLEXIBLE_CHALLENGE3.settings,
        description: {
          ...FLEXIBLE_CHALLENGE3.settings.description,
          media: EDITORX_MEDIA.MealForRunners,
        },
      },
    },
  },
];

export const STEPS: ParticipantStep[] = [
  {
    id: 'test-step-1',
    source: {
      stepType: StepType.ARTICLE,
      id: 'test-step-1-original',
      description: {
        title: 'The Basics 🥛',
        details:
          '{"blocks":[{"key":"foo","text":"Whether you’re making a birthday cake, loaf of bread, or a batch of cookies, most of the ingredients are the same.","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{"dynamicStyles":{"line-height":"1.38"}}},{"key":"deqbf","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"ep9oc","text":"Let’s focus on a basic cake as an example. Take a look at this list of ingredients, along with some healthier alternatives. You can substitute any in equal measure.","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{"dynamicStyles":{"line-height":"1.38"}}},{"key":"5dclm","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"a2rtk","text":"Flours: Flour is like a foundation, holding all the ingredients together. Not all flours are the same; some are just for bread while others are good for cake. Almond, oat, and teff flour are healthier alternatives.","type":"unstyled","depth":0,"inlineStyleRanges":[{"offset":0,"length":6,"style":"BOLD"}],"entityRanges":[],"data":{"dynamicStyles":{"line-height":"1.38"}}},{"key":"emocu","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"1a2s4","text":"Leavening Agents: Leavening agents make treats light and fluffy. The most common ones are baking powder, baking soda, and yeast. None of these are really unhealthy, but yeast is the most natural.","type":"unstyled","depth":0,"inlineStyleRanges":[{"offset":0,"length":16,"style":"BOLD"}],"entityRanges":[],"data":{"dynamicStyles":{"line-height":"1.38"}}},{"key":"c3cmk","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"4to1h","text":"Fats: Butter, oil, shortening, and margarine bring good texture and strong flavor. You can substitute these with avocado oil, canola oil, and more.","type":"unstyled","depth":0,"inlineStyleRanges":[{"offset":0,"length":4,"style":"BOLD"}],"entityRanges":[],"data":{"dynamicStyles":{"line-height":"1.38"}}},{"key":"f22d2","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"4sbtj","text":"Sweeteners: There’s a reason we all love sugar, but there are healthier options out there. Honey and maple syrup are some of the more natural options.","type":"unstyled","depth":0,"inlineStyleRanges":[{"offset":0,"length":10,"style":"BOLD"}],"entityRanges":[],"data":{"dynamicStyles":{"line-height":"1.38"}}},{"key":"cm9j0","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"2tbl3","text":"You’ll also need water, milk, eggs, and something for flavor. The list never ends, but knowing what alternatives are available will help you be creative later on 💪","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{"dynamicStyles":{"line-height":"1.38"}}},{"key":"33b95","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{},"VERSION":"8.29.3"}',
      },
      delay: 0,
    },
    // timeFrame: { start: '2020-12-14T21:00:00Z' },
    transitions: [
      { state: 'RUNNING', occurredAt: '2020-12-15T07:17:33.202Z' },
      { state: 'PENDING', occurredAt: '2020-12-15T07:17:33.202Z' },
    ],
    dateFrame: { start: '2020-12-15' },
  },
  {
    id: 'test-step-2',
    source: {
      id: 'test-step-2-original',
      stepType: StepType.ARTICLE,
      description: {
        title: 'The Tools 🍪',
        details:
          '{"blocks":[{"key":"foo","text":"You can buy tons of fancy gadgets, but there’s really only a handful of tools you need in order to make a basic cake, including:","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{"dynamicStyles":{"line-height":"1.38"}}},{"key":"7evo9","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"7f9vs","text":"An oven and cake pan","type":"unordered-list-item","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{"dynamicStyles":{"line-height":"1.38"}}},{"key":"frbtn","text":"Measuring spoons and cups","type":"unordered-list-item","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{"dynamicStyles":{"line-height":"1.38"}}},{"key":"bt1uu","text":"Whisks, spatulas, and other utensils","type":"unordered-list-item","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{"dynamicStyles":{"line-height":"1.38"}}},{"key":"84ojb","text":"Bowls and pans","type":"unordered-list-item","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{"dynamicStyles":{"line-height":"1.38"}}},{"key":"fcmvr","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"c0tnb","text":"There are a ton of options out there, so choose sets that are long-lasting and comfortable for you to use.","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{"dynamicStyles":{"line-height":"1.38"}}},{"key":"bm45h","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"b15ph","text":"Whether you’re splurging on a ton of sugar or trying to stay healthier, it’s important to be comfortable with all these gadgets. Try buying smaller trays and bowls to limit your portion sizes.","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{"dynamicStyles":{"line-height":"1.38"}}},{"key":"b1qkn","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{},"VERSION":"8.29.3"}',
      },
      delay: 0,
    },
    // timeFrame: { start: '2020-12-14T21:00:00Z' },
    transitions: [
      { state: 'RUNNING', occurredAt: '2020-12-15T07:17:33.202Z' },
      { state: 'PENDING', occurredAt: '2020-12-15T07:17:33.202Z' },
    ],
    dateFrame: { start: '2020-12-15' },
  },
  {
    id: 'test-step-3',
    source: {
      id: 'test-step-3-original',
      stepType: StepType.ARTICLE,
      description: {
        title: ' Techniques 🍰',
        details:
          '{"blocks":[{"key":"foo","text":"It’s only easy to follow a recipe if you understand what it’s asking you to do.  To make a cake, you may need to:","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{"dynamicStyles":{"line-height":"1.38"}}},{"key":"843kv","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"4pgn5","text":"Beat: Stir quickly. This is usually used to talk about wet ingredients.","type":"unordered-list-item","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{"dynamicStyles":{"line-height":"1.38"}}},{"key":"bfd1u","text":"Blend: Stir the ingredients together.","type":"unordered-list-item","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{"dynamicStyles":{"line-height":"1.38"}}},{"key":"70r3p","text":"Fold: Gently mix two items together, careful not to knock out any air.","type":"unordered-list-item","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{"dynamicStyles":{"line-height":"1.38"}}},{"key":"e7cgi","text":"Mix: Combine ingredients in the same bowl.","type":"unordered-list-item","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{"dynamicStyles":{"line-height":"1.38"}}},{"key":"7h9tb","text":"Whip: Beating with a whisk.","type":"unordered-list-item","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{"dynamicStyles":{"line-height":"1.38"}}},{"key":"foqbs","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"2t8lb","text":"You’ll pick it up as you go.  If you’re ready to add more words to your baking vocabulary, grab a nearby cookbook and read through the directions.  Look up any terms you don’t know.","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{"dynamicStyles":{"line-height":"1.38"}}},{"key":"fufb0","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{},"VERSION":"8.29.3"}',
      },
      delay: 0,
    },
    // timeFrame: { start: '2020-12-14T21:00:00Z' },
    transitions: [
      { state: 'RUNNING', occurredAt: '2020-12-15T07:17:33.202Z' },
      { state: 'PENDING', occurredAt: '2020-12-15T07:17:33.202Z' },
    ],
    dateFrame: { start: '2020-12-15' },
  },
  {
    id: 'test-step-4',
    source: {
      id: 'test-step-4-original',
      stepType: StepType.ARTICLE,
      description: {
        title: 'Other Tips  🥧',
        details:
          '{"blocks":[{"key":"foo","text":"Before you make your first healthy cake, there are a few extra tips to keep in mind.","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{"dynamicStyles":{"line-height":"1.38"}}},{"key":"q423","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"1n2qu","text":"First, don’t be afraid to try something new. Healthy alternatives are out there! Make sure your oven is preheated before you put in your mixture. Many treats need that first zap of heat to bake just right.","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{"dynamicStyles":{"line-height":"1.38"}}},{"key":"9b3fv","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"8q0ta","text":"When measuring, don’t pack down the ingredients.  Just fill to the top without forcing. Finally, stay organized.  Do you have everything you need for a recipe?  Read the instructions beforehand to make sure.","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{"dynamicStyles":{"line-height":"1.38"}}},{"key":"23dug","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{},"VERSION":"8.29.3"}',
      },
      delay: 0,
    },
    // timeFrame: { start: '2020-12-14T21:00:00Z' },
    transitions: [
      { state: 'RUNNING', occurredAt: '2020-12-15T07:17:33.202Z' },
      { state: 'PENDING', occurredAt: '2020-12-15T07:17:33.202Z' },
    ],
    dateFrame: { start: '2020-12-15' },
  },
];

export const CALENDAR_STEPS = {
  steps: [
    {
      id: '12ff3dc2-898c-4e75-b192-2d0f1274b5ee',
      settings: {
        general: {
          description: {
            title: 'What’s a business plan, anyway?',
            details:
              '{"blocks":[{"key":"foo","text":"A business plan explains what a business does, how it plans on making money, and why other people should care.","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{"dynamicStyles":{"line-height":"1.38"}}},{"key":"82k77","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"c6260","text":"Investors aren’t your only audience. Business plans can help you keep track of why you created your business in the first place. Having data, goals, and a clear vision all in one place can help you make important decisions later on.","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{"dynamicStyles":{"line-height":"1.38"}}},{"key":"1j79e","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{},"VERSION":"8.29.3"}',
          },
          duration: { unit: 'DAYS', value: 1 },
          recurrenceSettings: { schedules: [] },
        },
        embedding: {
          startConditions: [
            {
              dependency: { container: {} },
              delay: { unit: 'DAYS', value: 0 },
            },
          ],
          isMilestone: false,
        },
      },
      createdAt: '2022-04-17T20:08:12.453Z',
      updatedAt: '2022-04-17T20:08:12.453Z',
    },
    {
      id: '2946d3d1-3aa5-4aef-8f26-40ca424514da',
      settings: {
        general: {
          description: {
            title: 'Why does the business exist?',
            details:
              '{"blocks":[{"key":"foo","text":"The first section of a business plan explains what exactly the business does. Opening a restaurant? Creating a travel agency? Be clear about what you do.","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{"dynamicStyles":{"line-height":"1.38"}}},{"key":"2n301","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"e740d","text":"Now explain why! Why are you passionate about this business? How did you get started? A few sentences about your story can go a long way in convincing someone to invest.","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{"dynamicStyles":{"line-height":"1.38"}}},{"key":"470ul","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"fjg9g","text":"Passion goes a long way. Be sure to share it.","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{"dynamicStyles":{"line-height":"1.38"}}},{"key":"1johl","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{},"VERSION":"8.29.3"}',
          },
          duration: { unit: 'DAYS', value: 1 },
          recurrenceSettings: { schedules: [] },
        },
        embedding: {
          startConditions: [
            {
              dependency: { container: {} },
              delay: { unit: 'DAYS', value: 1 },
            },
          ],
          isMilestone: false,
        },
      },
      createdAt: '2022-04-17T20:08:12.453Z',
      updatedAt: '2022-04-17T20:08:12.453Z',
    },
    {
      id: '73a7110a-1aa8-4106-a87a-0ad682a1588e',
      settings: {
        general: {
          description: {
            title: 'How will you make it happen?',
            details:
              '{"blocks":[{"key":"foo","text":"You can’t provide services or products without the right resources.","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{"dynamicStyles":{"line-height":"1.38"}}},{"key":"52kn7","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"45dq7","text":"This is the place to list out what you have: locations, workers, physical supplies, and previous investments. Prove that you’ve thought through every step of the process and know how to get the job done.","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{"dynamicStyles":{"line-height":"1.38"}}},{"key":"blkfh","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{},"VERSION":"8.29.3"}',
          },
          duration: { unit: 'DAYS', value: 1 },
          recurrenceSettings: { schedules: [] },
        },
        embedding: {
          startConditions: [
            {
              dependency: { container: {} },
              delay: { unit: 'DAYS', value: 1 },
            },
          ],
          isMilestone: false,
        },
      },
      createdAt: '2022-04-17T20:08:12.454Z',
      updatedAt: '2022-04-17T20:08:12.454Z',
    },
    {
      id: 'e6eb793e-5a9e-43e9-a771-308db43ca2fc',
      settings: {
        general: {
          description: {
            title: 'What’s next?',
            details:
              '{"blocks":[{"key":"foo","text":"Every business plan needs to end with a clear statement about why your business is worth investing in. A big part of this is showing your expectations for the future.","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{"dynamicStyles":{"line-height":"1.38"}}},{"key":"75dd8","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"eadsh","text":"How will your business expand in five years, or ten? How big can it grow? Be realistic, but also hopeful. This is the place to lay out your vision and really emphasise why the chance to be part of your business is a can’t-miss opportunity.","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{"dynamicStyles":{"line-height":"1.38"}}},{"key":"2r8rb","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{},"VERSION":"8.29.3"}',
          },
          duration: { unit: 'DAYS', value: 1 },
          recurrenceSettings: { schedules: [] },
        },
        embedding: {
          startConditions: [
            {
              dependency: { container: {} },
              delay: { unit: 'DAYS', value: 1 },
            },
          ],
          isMilestone: false,
        },
      },
      createdAt: '2022-04-17T20:08:12.454Z',
      updatedAt: '2022-04-17T20:08:12.454Z',
    },
    {
      id: 'a8e98de7-b88a-4b57-8573-e8d9f27cb4a4',
      settings: {
        general: {
          description: {
            title: 'Bring it all together',
            details:
              '{"blocks":[{"key":"foo","text":"Think about how you’ll present your plan and what works best for you.","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{"dynamicStyles":{"line-height":"1.38"}}},{"key":"1n47g","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"j682","text":"Sometimes business plans are sent through email, and other times they’re shared in a meeting.  Either way, get familiar with every part of it. Be prepared to answer questions and share your passion.","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{"dynamicStyles":{"line-height":"1.38"}}},{"key":"3pm5e","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"e7en3","text":"And in the future, come back to your business plan to make more decisions and remember where you started.","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{"dynamicStyles":{"line-height":"1.38"}}}],"entityMap":{},"VERSION":"8.29.3"}',
          },
          duration: { unit: 'DAYS', value: 1 },
          recurrenceSettings: { schedules: [] },
        },
        embedding: {
          startConditions: [
            {
              dependency: { container: {} },
              delay: { unit: 'DAYS', value: 2 },
            },
          ],
          isMilestone: false,
        },
      },
      createdAt: '2022-04-17T20:08:12.454Z',
      updatedAt: '2022-04-17T20:08:12.454Z',
    },
    {
      id: '3db54512-21c1-4bf3-a489-1b56fdf35f88',
      settings: {
        general: {
          description: {
            title: 'What will it cost?',
            details:
              '{"blocks":[{"key":"foo","text":"What about the things you need? New locations? Hiring new employees? Provide as many details as possible.","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{"dynamicStyles":{"line-height":"1.38"}}},{"key":"ejc16","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"ad2lf","text":"After listing the expected expenses, focus on the exciting stuff: profits. How much do you expect your business to earn by the end of the year? And how can your investors benefit from your success?","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{"dynamicStyles":{"line-height":"1.38"}}},{"key":"crfp3","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{},"VERSION":"8.29.3"}',
          },
          duration: { unit: 'DAYS', value: 1 },
          recurrenceSettings: { schedules: [] },
        },
        embedding: {
          startConditions: [
            {
              dependency: { container: {} },
              delay: { unit: 'DAYS', value: 2 },
            },
          ],
          isMilestone: false,
        },
      },
      createdAt: '2022-04-17T20:08:12.454Z',
      updatedAt: '2022-04-17T20:08:12.454Z',
    },
  ],
};

export const SECTIONS: ParticipantSection[] = [
  {
    id: 'a929516a-9aa8-4fe2-bdaa-1d8c9365f597',
    source: {
      id: 'e7083d62-cee9-49c7-a429-44f460a2def5',
      description: {
        title: 'The Vocab ',
      },
      delayInDays: 0,
      steps: [],
    },
    steps: [STEPS[0], STEPS[1]],
  },
  {
    id: 'e91dfa1c-43fb-4bfc-a8f4-a9b30761fb98',
    source: {
      id: '4354b221-a6d1-4cc0-b851-0cf1adb851a9',
      description: {
        title: 'Technique',
      },
      delayInDays: 0,
      steps: [],
    },
    steps: [STEPS[2], STEPS[3]],
  },
];

export const PARTICIPANT = {
  id: 'test-participant-id',
  member: {
    id: 'test-member-id',
    fullName: 'User Userovich',
    imageUrl: null,
    contactId: null,
  },
  challenge: null,
  timeFrame: { start: '2020-12-14T21:00:00Z' },
  stepsSummary: {
    stepsNumber: 6,
    completedStepsNumber: 0,
    failedStepsNumber: 0,
    postedFeedbacksNumber: 0,
    lastEvent: {
      stepId: 'test-step-id',
      transition: {
        state: 'RUNNING',
        occurredAt: '2020-12-15T07:17:33.202Z',
      },
    },
  },
  orderIds: [],
  transitions: [
    { state: 'JOINED', occurredAt: '2020-12-15T07:17:33.201Z' },
    { state: 'RUNNING', occurredAt: '2020-12-15T07:17:32.777Z' },
  ],
  timezone: 'Europe/Kyiv',
  dateFrame: { start: '2020-12-15' },
  performance: 0,
};
